var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Drawer', {
    attrs: {
      "title": _vm.title,
      "closable": false,
      "width": _vm.width
    },
    on: {
      "on-visible-change": _vm.onVisibleChange
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "h-full flex flex-col justify-between"
  }, [_c('Form', {
    attrs: {
      "model": _vm.config,
      "label-position": "top",
      "label-colon": ""
    }
  }, [_c('FormItem', {
    attrs: {
      "label": $t("e2ri2", "代码"),
      "prop": "code"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": $t("2jc2ft5", "请输入代码")
    },
    model: {
      value: _vm.config.code,
      callback: function ($$v) {
        _vm.$set(_vm.config, "code", $$v);
      },
      expression: "config.code"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": $t("eyrn2", "名称"),
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": $t("2jb6fo5", "请输入名称")
    },
    model: {
      value: _vm.config.name,
      callback: function ($$v) {
        _vm.$set(_vm.config, "name", $$v);
      },
      expression: "config.name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": $t("g2z7o64", "管理范围"),
      "prop": "unitIds"
    }
  }, [_c('div', {
    staticClass: "flex gap-2 flex-col"
  }, [_c('RadioGroup', {
    on: {
      "on-change": function ($event) {
        return _vm.selectScope($event);
      }
    },
    model: {
      value: _vm.config.unitIds,
      callback: function ($$v) {
        _vm.$set(_vm.config, "unitIds", $$v);
      },
      expression: "config.unitIds"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "curr"
    }
  }, [_vm._v($t("cdi53x4", "当前组织"))]), _c('Radio', {
    attrs: {
      "label": "next"
    }
  }, [_vm._v($t("adj69r4", "下级组织"))])], 1), _c('Select', {
    attrs: {
      "value": _vm.entityLists,
      "multiple": "",
      "placeholder": $t("z5j1yr7", "请选择管理范围")
    }
  }, _vm._l(_vm.entityList, function (item) {
    return _c('Option', {
      key: item.key,
      attrs: {
        "value": item.key
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)]), _c('FormItem', {
    attrs: {
      "label": $t("dnlejy4", "权限配置")
    }
  })], 1), _c('div', {
    staticClass: "flex justify-end gap-2"
  }, [_c('Button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v($t("kzjg2", "确定"))])], 1)], 1), _c('unit-tree-modal', {
    ref: "orgTreeModalRef",
    on: {
      "on-update": _vm.updateIdentity
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };